$(document).ready(function() {
    var contact_form = $('form[name=contact-form]');

    contact_form.validate({
        ignore: '.ignore',
        rules: {
            full_name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            }
        },
        errorPlacement: function () {
            return false;
        },
        submitHandler: function () {
            $('.loading').remove();
            contact_form.append('<img class="loading" style="float:right;margin-top:10px" width="30" src="' + $(document.body).data('base') + '/images/site/loading.gif">');

            $.ajax({
                type: "POST",
                url: $(document.body).data('base') + "/ajax/contact-form.php",
                data: contact_form.serialize(),
                success: function (response) {
                    console.log(response);
                    var $response = JSON.parse(response);
                    contact_form.find('.loading').remove();

                    if (typeof $response === 'object' && $response !== null && $response.status !== 'success') {
                        swal({
                            title: '', 
                            text: $response.message, 
                            type: $response.status,
                            confirmButtonColor: "#f15a24"
                        });
                    } else {
                        contact_form.find("input, textarea, .g-recaptcha, select, .select2-container").remove();
                         swal({
                            title: 'Thank you!', 
                            text: $response.message, 
                            type: $response.status,
                            confirmButtonColor: "#f15a24"
                        });
                        ga('send', 'pageview', '/contact-us-submit');
                        gtag("event", "contact_us_submit");
                    }
                },
                error: function () {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });
});